import React from 'react';

export function TreeIllustration({ className = '' }) {
  return (
    <svg viewBox="0 0 200 280" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="90" y="200" width="20" height="60" rx="4" fill="#6B4226" fillOpacity="0.6" />
      <ellipse cx="100" cy="160" rx="50" ry="60" fill="#1B3A2D" fillOpacity="0.25" />
      <ellipse cx="100" cy="130" rx="40" ry="50" fill="#1B3A2D" fillOpacity="0.35" />
      <ellipse cx="100" cy="100" rx="30" ry="40" fill="#1B3A2D" fillOpacity="0.5" />
      <ellipse cx="70" cy="150" rx="25" ry="35" fill="#87A96B" fillOpacity="0.3" />
      <ellipse cx="130" cy="145" rx="22" ry="32" fill="#87A96B" fillOpacity="0.3" />
    </svg>
  );
}

export function LeafCluster({ className = '' }) {
  return (
    <svg viewBox="0 0 120 80" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M60 70 C60 70 20 50 25 20 C30 5 55 2 60 10 C65 2 90 5 95 20 C100 50 60 70 60 70Z" fill="#1B3A2D" fillOpacity="0.2" />
      <path d="M40 65 C40 65 10 48 15 25 C19 12 38 10 40 18 C42 10 61 12 65 25 C70 48 40 65 40 65Z" fill="#87A96B" fillOpacity="0.25" />
      <path d="M80 60 C80 60 55 45 58 22 C61 9 78 8 80 15 C82 8 99 9 102 22 C105 45 80 60 80 60Z" fill="#87A96B" fillOpacity="0.2" />
      <path d="M60 70 L60 40" stroke="#1B3A2D" strokeWidth="1.5" strokeOpacity="0.4" />
      <path d="M40 65 L40 35" stroke="#87A96B" strokeWidth="1.5" strokeOpacity="0.3" />
    </svg>
  );
}

export function ForestBackground({ className = '' }) {
  return (
    <svg viewBox="0 0 800 300" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
      {/* Far background trees */}
      {[50, 150, 250, 350, 450, 550, 650, 750].map((x, i) => (
        <g key={i} transform={`translate(${x}, 50)`}>
          <rect x="12" y="120" width="8" height="40" fill="#6B4226" fillOpacity="0.15" rx="2" />
          <ellipse cx="16" cy="100" rx="20" ry="30" fill="#1B3A2D" fillOpacity="0.1" />
          <ellipse cx="16" cy="78" rx="15" ry="24" fill="#1B3A2D" fillOpacity="0.12" />
          <ellipse cx="16" cy="58" rx="10" ry="18" fill="#1B3A2D" fillOpacity="0.15" />
        </g>
      ))}
      {/* Foreground ground */}
      <ellipse cx="400" cy="280" rx="450" ry="40" fill="#1B3A2D" fillOpacity="0.08" />
    </svg>
  );
}

export function WoodRingPattern({ className = '' }) {
  return (
    <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      {[48, 40, 32, 24, 16, 8].map((r, i) => (
        <circle key={i} cx="50" cy="50" r={r} stroke="#6B4226" strokeOpacity={0.04 + i * 0.01} strokeWidth="1.5" />
      ))}
    </svg>
  );
}
